<template>

  <select class="form-control" @change="change">
    <option value=""></option>
    <option v-for="(item, index) in templatemails" :value="item._id" :selected="value==item._id">{{ item.name }}</option>
  </select>

</template>

<script>
export default {
  name: 'SelectTemplatemail',
  props: {
    value: false
  },
  data () {
    return {
      'templatemails': []
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getTemplatemails', {sort: 'name', limit: 2000})
      .then((result) => {
        this.templatemails = result.docs
      })
    },
    change (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectTemplatemail.vue